var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    [
      _c(
        "cms-heading",
        { attrs: { title: "Acties", icon: "entypo-flag" } },
        [
          _c(
            "cms-button",
            {
              attrs: { disabled: !_vm.hasFilter },
              on: { click: _vm.resetFilters },
            },
            [_vm._v("Reset filters")]
          ),
          _c(
            "div",
            { staticClass: "cms-segmented-control" },
            [
              _c(
                "cms-button",
                {
                  class: { active: _vm.viewMode === "LIST" },
                  on: {
                    click: function ($event) {
                      _vm.viewMode = "LIST"
                    },
                  },
                },
                [_vm._v("Lijst")]
              ),
              _c(
                "cms-button",
                {
                  class: { active: _vm.viewMode === "MAP" },
                  on: {
                    click: function ($event) {
                      _vm.viewMode = "MAP"
                    },
                  },
                },
                [_vm._v("Kaart")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("complex-filter-panel", {
        attrs: { options: _vm.filterOptions },
        model: {
          value: _vm.filter,
          callback: function ($$v) {
            _vm.filter = $$v
          },
          expression: "filter",
        },
      }),
      _c(
        "keep-alive",
        [
          _vm.viewMode === "LIST"
            ? _c("actions-list", {
                ref: "actionList",
                attrs: { filter: _vm.filter },
                on: { "update-state": _vm.updateState },
              })
            : _vm._e(),
          _vm.viewMode === "MAP"
            ? _c("actions-map", {
                ref: "actionMap",
                attrs: { filter: _vm.filter },
                on: { "update-state": _vm.updateState },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }